var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-handle" },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedUserIds.value.length,
              expression: "selectedUserIds.value.length",
            },
          ],
          staticClass: "group-handle__info",
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t("pc_biz_group_select_info", [
                _vm.selectedUserIds.value.length,
              ]) /* 已选择 {0} 人 */
            )
          ),
        ]
      ),
      _c(
        "yxt-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedUserIds.value.length,
              expression: "selectedUserIds.value.length",
            },
          ],
          attrs: { type: "text" },
          on: {
            click: function ($event) {
              return _vm.setPage("Group")
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("pc_biz_group_move_group") /* 移动分组 */) + " ")]
      ),
      _c(
        "yxt-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.groupList.length && _vm.selectedUserIds.value.length,
              expression: "groupList.length && selectedUserIds.value.length",
            },
          ],
          attrs: { type: "text" },
          on: {
            click: function ($event) {
              return _vm.removeMember()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("pc_biz_group_remove_group") /* 移出小组 */))]
      ),
      _c(
        "yxt-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedUserIds.value.length,
              expression: "selectedUserIds.value.length",
            },
          ],
          attrs: { type: "text" },
          on: {
            click: function ($event) {
              return _vm.setSelectUser([])
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("pc_biz_group_cancel_select") /* 取消选择 */))]
      ),
      _c(
        "yxt-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedUserIds.value.length && _vm.action,
              expression: "selectedUserIds.value.length && action",
            },
          ],
          attrs: { type: "text" },
          on: {
            click: function ($event) {
              return _vm.deleteUser(_vm.selectedUserIds.value)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("pc_biz_group_batchdel") /* 批量删除 */))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }